"use client"

import type { I18nLocale } from "@/modules/i18n/types"
import type { FunctionComponent } from "react"

import { useEffect, useState } from "react"

import { Text } from "@jobteaser/spark/components/Text/Text"

import { DATE_FORMATS, getDate, getRemainingTime } from "@/modules/dates/dates"

type JobAdCardTimeProps = {
  date: string | Date
  locale: I18nLocale
  timeZone: Intl.ResolvedDateTimeFormatOptions["timeZone"]
}

export const JobAdCardTime: FunctionComponent<JobAdCardTimeProps> = ({ date, locale, timeZone }) => {
  const [renderTimeZone, setRenderTimeZone] = useState(timeZone)

  const remainingTime = getRemainingTime({
    date,
    locale,
    reverse: true,
    timeZone: renderTimeZone,
  })

  const time =
    remainingTime ||
    getDate({
      date: new Date(date),
      dateFormat: DATE_FORMATS.FULL_DATETIME,
      locale,
      timeZone: renderTimeZone,
    })

  useEffect(() => {
    setRenderTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone)
  }, [])

  return (
    <Text variant="caption1" weight="regular" as="time">
      {time}
    </Text>
  )
}
